import { createIcon } from '@chakra-ui/react';

export const SalesForceMenuIcon = createIcon({
  displayName: 'SalesForceMenuIcon',
  viewBox: '0 0 40 40',
  path: (
    <>
      <rect
        x='-2.0625'
        y='-4.24292'
        width='44.1237'
        height='49.4845'
        fill='url(#pattern0_sf)'
      />
      <defs>
        <pattern
          id='pattern0_sf'
          patternContentUnits='objectBoundingBox'
          width='1'
          height='1'
        >
          <use
            xlinkHref='#image0_19114_7548'
            transform='scale(0.0046729 0.00416667)'
          />
        </pattern>
        <image
          id='image0_19114_7548'
          width='214'
          height='240'
          xlinkHref='data:image/png;base64,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'
        />
      </defs>
    </>
  ),
});
